import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import { Router, Link, Location } from '@reach/router';
import Layout from '../components/Layout/Layout';
import { siteTitle } from '../../data/SiteConfig';
import { isLoggedIn } from '../common/utils/cookie-utils';
import { QueryParamProvider } from 'use-query-params';
import { navigate } from 'gatsby';
import LandingPage from '../common/LandingPage/LandingPage';
import { window } from 'window-or-global';

export default function IndexPage() {
  const userType = () => {
    if (!window?.location?.href) return '';
    let url = new URL(window?.location?.href);
    return url?.searchParams?.get('bplogin');
  };

  const [btn, setbtn] = useState(userType() ? 'bp' : 'rm');

  useEffect(() => {
    isLoggedIn() ? navigate('/app/dashboard') : null;
  }, []);

  return (
    <Layout>
      <div className="homepage">
        <Helmet
          title={`${btn == 'rm' ? 'RM Login' : 'BP Login'} | ${siteTitle}`}
        >
          <link
            rel="icon"
            href="https://fincity-public.s3.ap-south-1.amazonaws.com/website/com/images/fincity-logo.png"
            type="image/icon type"
          />
          <link
            rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
          />
        </Helmet>
        <QueryParamProvider ReactRouterRoute={Location}>
          <LandingPage btn={btn} setbtn={setbtn} />
        </QueryParamProvider>
      </div>
    </Layout>
  );
}
